import React, { Component } from "react";
import TeamsTableRow from "../../components/teams/TeamsTableRow";
import ClubsPSD from "../../constants/ClubsPSD";
import { languages } from "../../constants/languages";
import {
  getFileTooLargeMessage,
  getUploadErrorMessage,
  validateFileSize,
} from "../../util/uploadErrors";

class TeamsTableRowContainer extends Component {
  state = {
    payed: false,
    players: [],
    playersLoaded: false,
    code: "",
    codeLoaded: false,
    copyButton: false,
    language: "",
    isUploadingLogo: false,
    logoUploadToastOpen: false,
    logoUploadToastMessage: "",
  };

  showLogoUploadToast = (message) => {
    this.setState({
      logoUploadToastOpen: true,
      logoUploadToastMessage: message,
    });
  };

  handleLogoUploadToastClose = () => {
    this.setState({ logoUploadToastOpen: false });
  };

  showCopyButton = (trueFalse) => {
    this.setState({ copyButton: trueFalse });
  };

  UNSAFE_componentWillMount = () => {
    if (this.props.team.signupId) {
      this.unsubscribeStatus = window.firebase
        .firestore()
        .collection("signupStatus")
        .doc(this.props.team.signupId)
        .onSnapshot((doc) => {
          if (doc.exists) {
            let status = doc.data().status;
            if (status === 1) {
              this.setState({ payed: true });
            }
            this.setState({
              payed: status === 1 ? true : false,
              language: doc.data().language || "",
            });
          }
        });
    }

    if (!this.props.refereesPage && !this.props.adminsPage) {
      this.unsubscribe2 = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("players")
        .where("team", "==", this.props.team.id)
        .onSnapshot((querySnapshot) => {
          var players = [];
          querySnapshot.forEach(function (doc) {
            let player = doc.data();
            player["id"] = doc.id;
            players.push(player);
          });

          this.setState({
            players: players,
            playersLoaded: true,
          });
        });
    }

    if (!this.props.adminsPage) {
      this.unsubscribe3 = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("teamCodes")
        .where("teamId", "==", this.props.team.id)
        .where("type", "==", this.props.refereesPage ? "referee" : "team")
        .onSnapshot((querySnapshot) => {
          var code = "";
          querySnapshot.forEach(function (doc) {
            code = doc.id;
          });
          let url =
            (this.props.tournament.isPSD || this.props.tournament.crqpsd
              ? "tournify.prosoccerdata.com/"
              : "tournifyapp.com/live/") + this.props.tournament.liveLink;
          if (!this.props.adminsPage && !this.props.refereesPage) {
            url += "/team/";
          } else if (this.props.refereesPage) {
            url += "/referee/";
          }

          url += this.props.team.id + "/" + code;
          this.setState({
            code: code && this.props.tournament.liveLink ? url : "",
            codeLoaded: true,
          });
        });
    }
  };

  componentWillUnmount = () => {
    if (this.unsubscribeStatus) {
      this.unsubscribeStatus();
    }
    if (this.unsubscribe2) {
      this.unsubscribe2();
    }
    if (this.unsubscribe3) {
      this.unsubscribe3();
    }
  };

  handleCheck = (event, type) => {
    let update = {};
    update[type] = event.target.checked;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teams")
      .doc(this.props.team.id)
      .update(update);
  };

  getStorageRef = () => {
    return window.firebase
      .app()
      .storage("gs://tournament-uploads/")
      .ref(
        "teamLogo/" +
          this.props.user.uid +
          "/" +
          this.props.tournament[".key"] +
          "/" +
          this.props.team.id
      );
  };

  handleLogoUploadStart = () => {
    this.setState({
      isUploadingLogo: true,
      logoUploadToastOpen: false,
    });
  };

  handleLogoUploadError = (error) => {
    this.setState({ isUploadingLogo: false });
    this.showLogoUploadToast(getUploadErrorMessage(error, 1));
  };

  handleLogoUploadSuccess = (filename) => {
    const storageRef = this.getStorageRef();
    storageRef
      .child(filename)
      .getMetadata()
      .then((metadata) => {
        const uploadedFileSize = parseInt((metadata || {}).size || "0", 10);
        if (uploadedFileSize > 1 * 1024 * 1024) {
          this.setState({ isUploadingLogo: false });
          this.showLogoUploadToast(getFileTooLargeMessage(1));
          storageRef.child(filename).delete().catch(() => {});
          return null;
        }
        return storageRef.child(filename).getDownloadURL();
      })
      .then((url) => {
        if (!url) {
          return;
        }
        return window.firebase
          .firestore()
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("teams")
          .doc(this.props.team.id)
          .update({ logoOriginal: url })
          .then(() => {
            this.setState({ isUploadingLogo: false });
          });
      })
      .catch((error) => {
        this.handleLogoUploadError(error);
      });
  };

  render() {
    let gbFlags = {};
    let gbFlag = undefined;
    if (((this.props.tournament.defaultFields || {})["country"] || {}).show) {
      gbFlags = {
        GBENG: require("../../img/gb-eng.svg"),
        GBNIR: require("../../img/gb-nir.svg"),
        GBSCT: require("../../img/gb-sct.svg"),
        GBWLS: require("../../img/gb-wls.svg"),
      };
      if (gbFlags[this.props.team.country]) {
        gbFlag = gbFlags[this.props.team.country];
      }
      // if (this.props.team.country === "GBNIR") {
      //   this.props.team.country = "GB";
      // }
    }
    let divisionStrings = [];
    let divisionsReferee = this.props.team["divisionsReferee"] || "all";
    if (divisionsReferee !== "all") {
      this.props.divisions.forEach((d) => {
        if (divisionsReferee.indexOf(d.id) !== -1) {
          divisionStrings.push(d.name);
        }
      });
    }
    let divisionsString =
      divisionsReferee === "all"
        ? languages.referees.allDivisions
        : divisionStrings.join(", ");

    let roleStrings = [];
    let roles = this.props.team["roles"] || "all";
    let roleNames = {
      0: languages.structure.ranks[0],
      1: languages.structure.ranks[1],
      2: languages.structure.ranks[2],
      3: languages.structure.ranks[3],
      4: languages.structure.ranks[4],
    };
    if (roles !== "all") {
      roles.forEach((r) => {
        roleStrings.push(roleNames[r]);
      });
    }
    let rolesString =
      roles === "all" ? languages.referees.allRoles : roleStrings.join(", ");

    let teamStrings = [];
    let exlcudeTeams = this.props.team["excludeTeams"] || [];
    exlcudeTeams.forEach((t) => {
      let team = this.props.allTeamsByKey[t];
      if (team) {
        teamStrings.push(team.name);
      }
    });

    let teamsString = teamStrings.join(", ");

    let psdClubTeam = "";
    if (this.props.tournament[".key"] === "G64irmoaJPIkFfYKkfUP") {
      psdClubTeam =
        (ClubsPSD.find((c) => c.id === this.props.team.psdClubId) || {}).naam ||
        "";
    }

    return (
      <TeamsTableRow
        {...this.props}
        handleCheck={this.handleCheck}
        gbFlag={gbFlag}
        payed={this.state.payed}
        language={this.state.language}
        user={this.props.user}
        players={this.state.players}
        divisionsString={divisionsString}
        rolesString={rolesString}
        teamsString={teamsString}
        code={this.state.code}
        codeLoaded={this.state.codeLoaded}
        showCopyButton={this.showCopyButton}
        copyButton={this.state.copyButton}
        psdClubTeam={psdClubTeam}
        isUploadingLogo={this.state.isUploadingLogo}
        logoUploadToastOpen={this.state.logoUploadToastOpen}
        logoUploadToastMessage={this.state.logoUploadToastMessage}
        onLogoUploadToastClose={this.handleLogoUploadToastClose}
        handleLogoUploadStart={this.handleLogoUploadStart}
        handleLogoUploadError={this.handleLogoUploadError}
        handleLogoUploadSuccess={this.handleLogoUploadSuccess}
        logoStorageRef={this.getStorageRef()}
        validateFileSize={validateFileSize}
      />
    );
  }
}

export default TeamsTableRowContainer;
